var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussia12X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#851c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#7a1c15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#691d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#5f1d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#5c1d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#851c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a62313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#c42a12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cf2c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#e16c43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#e5784c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#e67e52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#e5784c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b56b4e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.501,
    y1: 1,
    x2: 0.501,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#851c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#9f2213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#b42612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#c32912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#cc2b12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#cf2c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#d43c1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#db5632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e16941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#e47449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#e5784c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#e78357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#eb9a6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#edab7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#f0b78b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f1be92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c094"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#851c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#7a1c15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#691d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#5f1d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#5c1d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#851c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#9f2213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#b42612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#c32912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#cc2b12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#cf2c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#d43d1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#da532f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#df643c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#e26f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#e4764b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#e5784c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f1c094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#f1c094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#e5784c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b56b4e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#083581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#08347e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#0a306d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#0c2e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#0c2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#083581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#0c4294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1051a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#135bb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1461c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#1563c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#1f70c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#2d81d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#368cd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3c93d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#3d95d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8cd6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#8cd6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#3d95d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4690c3"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.419,
    y1: 0.457,
    x2: 0.692,
    y2: 0.546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c1d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#781c15",
    stopOpacity: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#851c13",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#391d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#4f1d19",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#5c1d19",
    stopOpacity: 0
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M33.3 30.94h-6.53c3.43-3.52 9-8.71 5.85-14.08-3.45-5.89-13.78-4.57-13.78 4.41h3.86c0-6.49 9.28-3.82 5.15 1.87-2.94 4.04-6.64 7.71-9.85 11.55l15.3.01v-3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M12.761 59.388h4.148l-.01-20.421-7.967 3.51c0 .116-.367 3.984-.367 3.984l4.206-2.098v15.025z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7 40.844h6.275c1.624 0 2.959 1.334 2.959 2.978V56.44c0 1.634-1.325 2.978-2.959 2.978H88.7V40.844z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.383 43.802v12.956c-1.151 2.369-2.659-1.46-2.659-6.633 0-5.182 2.195-9.118 2.659-6.323z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.291 31.929 40.394 68.061l46.111-.019c3.916.106 6.749-9.359 6.797-18.303.261-7.996-2.823-17.81-6.739-17.81H51.291z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.291 31.929 40.394 68.061l-31.859.01C6.031 67.81 2 61.264 2.067 49.894c.058-9.717 3.065-17.704 6.488-17.965h42.736z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.553 51.992s10.626-16.398 9.05-17.588c-1.576-1.18-5.328.213-5.328.213s-6.797 15.925-5.792 16.224c1.006.309 2.069 1.151 2.069 1.151z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.055 52.514-9.437 15.547h-1.653l4.138-10.23z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.183 34.569s-6.488 19.106-5.995 19.173 8.509.039 8.509.039L39.35 66.205s-.184.667 1.035-.261c1.218-.938 17.104-15.818 17.104-15.818l-10.761.358 7.687-16.572-12.231.657z",
    opacity: 0.32,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.245 33.93s-5.531 19.338-5.037 19.405 8.344-.048 8.344-.048l-5.134 12.618s-.445.619.774-.309 16.901-15.46 16.901-15.46H46.544L53.97 33.95l-12.724-.019z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    opacity: 0.3,
    y: 25.64,
    x: 1.693,
    transform: "translate(.014 1.037) scale(.9669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.946 55.743h-6.314c3.316-3.403 8.702-8.422 5.647-13.614-3.336-5.695-13.314-4.419-13.314 4.264h3.732c0-6.275 8.973-3.693 4.979 1.808-2.843 3.906-6.42 7.455-9.524 11.167l14.793.01v-3.635zm18.729-3.703H84.02V39.21h-3.258L70.319 52.04v3.626h9.969v3.781h3.732v-3.781h3.655V52.04zm-7.387-6.807v6.807h-5.647l5.647-6.807z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: -0.319,
    y: -0.444
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 1.363,
    y: 25.19,
    transform: "translate(.014 1.037) scale(.9669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.618 55.308h-6.314c3.316-3.403 8.702-8.422 5.647-13.614-3.336-5.695-13.314-4.419-13.314 4.264h3.732c0-6.275 8.973-3.693 4.979 1.808-2.843 3.906-6.42 7.455-9.524 11.167l14.793.01v-3.635zm18.738-3.713h-3.655v-12.83h-3.258L70 51.595v3.626h9.969v3.781h3.732v-3.781h3.655v-3.626zm-7.387-6.807v6.807h-5.647l5.647-6.807z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia12X24);
export default __webpack_public_path__ + "static/media/russia_12x24.cf48b905d9e4203ed3f6a55c616ceefc.svg";
export { ForwardRef as ReactComponent };